exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-box[data-v-a339119a] {\n  border-radius: 7px;\n  box-shadow: 0 3.5px 14px 3.5px rgba(0, 0, 0, 0.25);\n  left: 14px;\n  position: fixed;\n  top: -250px;\n  transition: all 0.25s ease-in;\n  width: calc(100vw - 28px);\n  z-index: 30;\n}\n.alert-box.\\--is-active[data-v-a339119a] {\n  top: 14px;\n}\n@media (min-width: 47.4375em) {\n.alert-box[data-v-a339119a] {\n    left: auto;\n    min-width: 12rem;\n    right: -500px;\n    top: 14px;\n    width: auto;\n}\n.alert-box.\\--is-active[data-v-a339119a] {\n    right: 14px;\n}\n}\n", ""]);

// exports
